export const AR_ATTACHMENT_ACCEPT = '.pdf,.jpg,.jpeg,.png,.txt,.tif,.eml';
export const AR_ATTACHMENT_MAX_SIZE = 20 * 1024 * 1024;
